import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {ReportsService} from '../../reports.service';
import {appColors} from '../../../core/styles/colors';
import {EChartsOption, SeriesOption} from 'echarts';
import {MatActivityDashboardV2ZoomDialogComponent} from './mat-activity-dashboard-v2-zoom-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {chartBarIcon, chartDefaultOptions, chartExpandIcon, chartPieIcon, zoomToTimeSeriesPoint} from '../../../core/styles/chart-defauls';
import {DurationPipe} from '../../../core/pipes/duration.pipe';
import {CallLogsV2DialogComponent} from '../../call-logs-v2/call-logs-v2-dialog.component';
import { NgxEchartsDirective } from 'ngx-echarts';

@Component({
    selector: 'app-activity-bar-chart-v2',
    templateUrl: './activity-bar-chart-v2.component.html',
    standalone: true,
    imports: [NgxEchartsDirective]
})
export class ActivityBarChartV2Component implements OnInit, OnDestroy, OnChanges {

  @Input() data: any[] = [];
  @Input() pieData: any[] = [];
  @Input() showExpand = false;
  @Input() chartType: 'line' | 'bar' | 'pie' = 'bar';
  @Input() additionalFilter: any = {};

  @ViewChild('expandBtn') expandBtn;

  colors = appColors;
  updateOptions: EChartsOption = {};
  initOptions = {};
  options: EChartsOption = {};

  barOptions: EChartsOption = {
    title: Object.assign({}, chartDefaultOptions.title, {
      text: 'Call Summary By Type'
    }),
    legend: {show: false},
    grid: Object.assign({}, chartDefaultOptions.grid),
    toolbox: [{
      show: true,
      feature: {
        dataZoom: {
          yAxisIndex: 'none'
        },
        myBar: {
          show: true,
          title: 'Switch to Bar Chart',
          icon: chartBarIcon,
          iconStatus: {
            myBar: 'emphasis',
            myPie: 'normal'
          },
          onclick: () => {
            console.log('on expand click');
            this.expandBtn.nativeElement.value = 'bar';
            this.expandBtn.nativeElement.click();
          }
        },
        myPie: {
          show: true,
          title: 'Switch to Pie Chart',
          icon: chartPieIcon,
          onclick: () => {
            console.log('on expand click');
            this.expandBtn.nativeElement.value = 'pie';
            this.expandBtn.nativeElement.click();
          }
        },
        saveAsImage: {},
        myZoom: {
          show: this.showExpand,
          title: 'Expand',
          icon: chartExpandIcon,
          onclick: () => {
            console.log('on expand click');
            this.expandBtn.nativeElement.value = 'zoom';
            this.expandBtn.nativeElement.click();
          }
        }
      }
    }],
    xAxis: {
      type: 'category',
      boundaryGap: true
    },
    yAxis: {
      type: 'value',
      scale: true,
      min: 0,
      axisLine: {
        show: true,
      },
      name: 'Total Count',
      nameGap: 30,
      nameRotate: 90,
      nameLocation: 'middle'
    },
    series: [{
      type: 'bar',
      name: 'Calls',
      barMaxWidth: 80,
    }],
    tooltip: {
      show: true,
      trigger: 'axis',
    },
  };

  pieOptions: EChartsOption = {
    title: Object.assign({}, chartDefaultOptions.title, {
      text: 'Call Summary By Time'
    }),
    legend: Object.assign({}, chartDefaultOptions.legend),
    grid: Object.assign({}, chartDefaultOptions.grid),
    toolbox: [{
      show: true,
      feature: {
        myBar: {
          show: true,
          title: 'Switch to Bar Chart',
          icon: chartBarIcon,
          iconStatus: 'select',
          onclick: () => {
            console.log('on expand click');
            this.expandBtn.nativeElement.value = 'bar';
            this.expandBtn.nativeElement.click();
          }
        },
        myPie: {
          show: true,
          title: 'Switch to Pie Chart',
          icon: chartPieIcon,
          iconStatus: {
            myBar: 'normal',
            myPie: 'emphasis'
          },
          onclick: () => {
            console.log('on expand click');
            this.expandBtn.nativeElement.value = 'pie';
            this.expandBtn.nativeElement.click();
          }
        },
        saveAsImage: {},
        myZoom: {
          show: this.showExpand,
          title: 'Expand',
          icon: chartExpandIcon,
          onclick: () => {
            console.log('on expand click');
            this.expandBtn.nativeElement.value = 'zoom';
            this.expandBtn.nativeElement.click();
          }
        }
      }
    }],
    series: [],
    tooltip: {
      show: true,
      trigger: 'item',
      axisPointer: {
        label: {
          formatter: (params) => {
            const name = this.reportsService.getExtensionName(params.value as string);
            return name || params.value;
          }
        }
      },
      valueFormatter: (value: any) => {
        return this.durationPipe.transform(value);
      }
    },
  };

  private chart: any;

  constructor(public reportsService: ReportsService, public dialog: MatDialog, public durationPipe: DurationPipe) {
    const resizeObserver = new ResizeObserver(() => {
      this.resizeChart();
    });
    resizeObserver.observe(document.body);
  }

  ngOnInit() {
    console.log('my on init');
  }

  resizeChart() {
    if (this.chart) {
      this.chart.resize();
    }
  }

  onChartInit($event: any) {
    this.chart = $event;
    console.log('on chart init:', $event);
  }

  ngOnDestroy() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('my on ngOnChanges');

    this.updateChart();
  }

  updateChart() {
    const groupedData = [...this.data];

    if (this.chartType === 'bar') {
      this.options = Object.assign({}, this.barOptions);
      this.options.xAxis = {
        data: groupedData.map(item => {
          return item.extension;
        })
      };
      this.options.series![0].data = groupedData.map(item => {
        return {
          itemStyle: {color: item.color},
          value: item.calls,
        };
      });
    } else if (this.chartType === 'pie') {
      this.options = Object.assign({}, this.pieOptions);
      const data = [...this.pieData];
      const pieTotalData = data.map(item => {
        return {
          value: item.totalTime,
          name: `Total. ${item.extension}`,
          itemStyle: {color: item.color},
        };
      });

      const pieAvgData = data.map(item => {
        return {
          value: item.avgTime,
          name: `Avg. ${item.extension}`,
          itemStyle: {color: item.color},
        };
      });

      const totalCalls: SeriesOption = {
        type: 'pie',
        name: 'Total Time',
        radius: '45%',
        center: ['25%', '60%'],
        data: pieTotalData,
      };

      const averageCalls: SeriesOption = {
        type: 'pie',
        name: 'Average Time',
        radius: '45%',
        center: ['75%', '60%'],
        data: pieAvgData,
      };

      const series: any[] = [];
      series.push(totalCalls);
      series.push(averageCalls);
      this.options.series = series;

    }

    this.options.toolbox![0].feature.myZoom.show = this.showExpand;

    this.updateOptions = {
      toolbox: this.options.toolbox,
      series: this.options.series,
    };
  }

  onExpandClick() {
    console.log(this.expandBtn.nativeElement.value);
    if (this.expandBtn.nativeElement?.value === 'bar') {
      this.chartType = 'bar';
      this.updateChart();
    } else if (this.expandBtn.nativeElement?.value === 'pie') {
      this.chartType = 'pie';
      this.updateChart();
    } else {
      this.dialog.open(MatActivityDashboardV2ZoomDialogComponent, {
        width: '90%',
        height: '90%',
        data: {
          chartData: this.data,
          chartPieData: this.pieData,
          showActivityPieChart: true,
          chartType: this.chartType,
        }
      });
    }
  }

  onChartClick($event: any) {
    console.log($event);
    if ($event.dataIndex == 0) { // incoming calls
      this.openCallLogs('isIncoming');
    } else if ($event.dataIndex == 1) { // outgoing calls
      this.openCallLogs('isOutgoing');
    } else if ($event.dataIndex == 2) { // incoming and missed calls
      this.openCallLogs('isIncoming', 'Missed');
    } else if ($event.dataIndex == 3) { // incoming and missed calls
      this.openCallLogs('isIncoming', 'Mailbox');
    }
  }

  openCallLogs(type?: string, status?: string) {
    console.log('open call logs dialog');
    let statuses = undefined;
    if (status) {
      statuses = [status];
    }
    let types = undefined;
    if (type) {
      types = [type];
    }

    this.dialog.open(CallLogsV2DialogComponent, {
      width: '90%',
      height: '90%',
      data: {
        filter: {
          types: types,
          statuses: statuses,
          startDate: this.additionalFilter.startDate,
          endDate: this.additionalFilter.endDate,
          domain: this.reportsService.selectedDomain
        }
      }
    });
  }
}
